/* Joonys: Klick auf die kleine Rating-Bar (unter dem Titel) → Smooth-Scroll
   zum großen Bewertungs-Widget (reviews.io Polaris). Delegiert + MutationObserver,
   weil beide Widgets asynchron nachladen. Inkl. Tastatur-/A11y-Support. */
(function () {
	var BAR = '.reviews-io-rating-bar-widget';
	var TARGET =
		'[data-reviewsio-widget="polaris"], reviewsio-product-reviews-widget, [id*="reviews_io_reviewsio_polaris"]';

	function scrollToReviews() {
		var t = document.querySelector(TARGET);
		if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	// Klick funktioniert auch, wenn das Widget erst später im DOM auftaucht.
	document.addEventListener('click', function (e) {
		if (e.target.closest && e.target.closest(BAR)) {
			e.preventDefault();
			scrollToReviews();
		}
	});

	// Rating-Bar als Button auszeichnen (Cursor via CSS), Enter/Space unterstützen.
	function enhance(bar) {
		if (bar.dataset.joonysScroll) return;
		bar.dataset.joonysScroll = '1';
		bar.setAttribute('role', 'button');
		bar.setAttribute('tabindex', '0');
		bar.setAttribute(
			'aria-label',
			(window.JoonysReviewsText && window.JoonysReviewsText.scrollLabel) || 'Zu den Bewertungen springen'
		);
		bar.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				scrollToReviews();
			}
		});
	}

	function scan() {
		document.querySelectorAll(BAR).forEach(enhance);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scan);
	} else {
		scan();
	}

	new MutationObserver(scan).observe(document.documentElement, {
		childList: true,
		subtree: true,
	});
})();
/* Joonys: reviews.io Polaris ans PDF-Design angleichen (JOO018 Bewertungen).
   Was CSS nicht kann, weil die Teile in getrennten DOM-Spalten liegen:
   1) "Name, Datum" inline hinter die Sterne (als Kopie; Originale versteckt
      das CSS über .joonys-reviews-item — Vue-Knoten werden nicht verschoben,
      damit Re-Renders des Widgets nicht brechen).
   2) Tab-Label "Produktbewertungen" -> "Bewertungen" (Design-Wording).
   Observer re-applied nach Widget-Re-Renders, geschrieben wird nur bei
   Abweichung, dadurch keine Endlosschleife. */
(function () {
	var WIDGET = '[data-reviewsio-widget="polaris"]';
	// Texte aus den Theme-Übersetzungen (reviews-i18n.liquid), mit dt. Fallback
	var TEXT = window.JoonysReviewsText || {};
	var TAB_SOURCE = TEXT.tabSource || 'Produktbewertungen';
	var TAB_TARGET = TEXT.tabReviews || 'Bewertungen';
	var REQUIRED_SUFFIX = TEXT.requiredSuffix || '(erforderlich)';
	var REQUIRED_NOTE = TEXT.requiredNote || '* erforderlich';
	var REQUIRED_RE = new RegExp('\\s*' + REQUIRED_SUFFIX.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');

	function decorateItem(item) {
		var stars = item.querySelector('.item__review .R-RatingStars--sm');
		if (!stars) return;
		var nameEl = item.querySelector('.item__meta span.cssVar-authorName');
		var dateEl = item.querySelector('.c-reviewDateTime');
		var name = nameEl ? nameEl.textContent.trim() : '';
		var date = dateEl ? dateEl.textContent.trim() : '';
		var text = name && date ? name + ', ' + date : name || date;
		if (!text) return;
		var tag = item.querySelector('.joonys-review-author');
		if (!tag) {
			tag = document.createElement('span');
			tag.className = 'joonys-review-author';
			stars.insertAdjacentElement('afterend', tag);
		}
		if (tag.textContent !== text) tag.textContent = text;
		item.classList.add('joonys-reviews-item');
	}

	function apply() {
		document.querySelectorAll(WIDGET).forEach(function (widget) {
			widget.querySelectorAll('.R-ContentList__item').forEach(decorateItem);
			var tab = widget.querySelector('#product-review-tab .R-TextHeading');
			if (tab && tab.textContent.trim() === TAB_SOURCE) {
				tab.textContent = TAB_TARGET;
			}
			// Formular klappt (per CSS-Order) oben unter der Section-Überschrift
			// auf → beim ersten Erscheinen dorthin scrollen, sonst öffnet es
			// außerhalb des Viewports (der Button sitzt weiter unten).
			var form = widget.querySelector('.ElementsWidget__form');
			if (form) {
				// Mockup-Wording: "(erforderlich)" in den Labels durch * ersetzen,
				// dafür unten links in der Button-Zeile die Legende "* erforderlich".
				form.querySelectorAll('.R-TextHeading--xxxs').forEach(function (label) {
					if (label.textContent.indexOf(REQUIRED_SUFFIX) !== -1) {
						label.textContent = label.textContent.replace(REQUIRED_RE, '*');
					}
				});
				var buttonsRow = form.querySelector('.R-flex-end-xxs');
				if (buttonsRow && !buttonsRow.querySelector('.joonys-required-note')) {
					var note = document.createElement('span');
					note.className = 'joonys-required-note';
					note.textContent = REQUIRED_NOTE;
					buttonsRow.insertBefore(note, buttonsRow.firstChild);
				}
				if (!form.dataset.joonysScrolled) {
					form.dataset.joonysScrolled = '1';
					var section = widget.closest('.shopify-section');
					var target = (section && section.querySelector('.apps-section-heading')) || widget;
					target.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		});
	}

	var scheduled = false;
	function schedule() {
		if (scheduled) return;
		scheduled = true;
		setTimeout(function () {
			scheduled = false;
			apply();
		}, 50);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', apply);
	} else {
		apply();
	}

	new MutationObserver(schedule).observe(document.documentElement, {
		childList: true,
		subtree: true,
		characterData: true,
	});
})();

